import React from 'react';

const Hero = () => {
    return (
        <div className="product-hero-container">
            <h1>Technology</h1>
            <h3>Sleek. Modern. Fast.</h3>
            <p>Check out our investment offerings →</p>
        </div>
    );
};

export default Hero;
